import {AnyAction, isRejectedWithValue} from '@reduxjs/toolkit'
import {MiddlewareType} from 'middlewares'
import {getPageSpace} from 'modules/analytics/trackEventHelpers'
import {
  error,
  sapiRtkQueryErrorToCommonErrorPayloadFormat
} from 'modules/common/actions/error'
import {clearError} from 'modules/common/actions/error'
import logSAPIService, {
  SAPIServiceEndpointNames,
  SAPIServiceStatus
} from 'performance/logSAPIService'
import timing from 'utils/timing'

import {searchApi} from '@vio/core/src/sapi/services/searchApi'
import {
  offersSearchErrored,
  offersSearchReceived,
  offersSearchStarted,
  offersSearchSucceeded
} from '@vio/core/src/sapi/services/searchApi/action'

const requestsTiming = timing()

const middleware: MiddlewareType =
  store => next => async (action: AnyAction) => {
    next(action)
    const {dispatch} = store

    const params = action?.meta?.arg?.originalArgs

    const space = getPageSpace(window.location.pathname)

    // getHotel
    if (searchApi.endpoints.getHotel.matchPending(action)) {
      requestsTiming.start('hotelFetch')

      logSAPIService(SAPIServiceEndpointNames.Hotel, SAPIServiceStatus.start, {
        params,
        space
      })
    }

    if (searchApi.endpoints.getHotel.matchFulfilled(action)) {
      const timings = requestsTiming.stop('hotelFetch')
      logSAPIService(SAPIServiceEndpointNames.Hotel, SAPIServiceStatus.done, {
        params,
        timings,
        space
      })
    }

    if (
      searchApi.endpoints.getHotel.matchRejected(action) &&
      isRejectedWithValue(action)
    ) {
      const timings = requestsTiming.stop('hotelFetch')
      logSAPIService(SAPIServiceEndpointNames.Hotel, SAPIServiceStatus.error, {
        params,
        timings,
        space
      })
    }

    // getOffers
    if (offersSearchStarted.match(action)) {
      requestsTiming.start('offersFetch')

      logSAPIService(SAPIServiceEndpointNames.Offers, SAPIServiceStatus.start, {
        paramsWithSearchId: action.payload,
        space
      })
      dispatch(clearError())
    }

    if (offersSearchReceived.match(action)) {
      logSAPIService(
        SAPIServiceEndpointNames.Offers,
        SAPIServiceStatus.received,
        {
          paramsWithSearchId: action?.payload,
          space
        }
      )
    }

    if (offersSearchSucceeded.match(action)) {
      const timings = requestsTiming.stop('offersFetch')
      logSAPIService(SAPIServiceEndpointNames.Offers, SAPIServiceStatus.done, {
        paramsWithSearchId: action?.payload,
        timings,
        space
      })
    }

    if (offersSearchErrored.match(action) && isRejectedWithValue(action)) {
      const timings = requestsTiming.stop('offersFetch')
      logSAPIService(
        SAPIServiceEndpointNames.Offers,
        SAPIServiceStatus.fatalError,
        {response: action?.payload, timings},
        'error'
      )
      dispatch(error(sapiRtkQueryErrorToCommonErrorPayloadFormat(action)))
    }
  }

export default middleware
